<template>
    <UnauthLayout>
        <Head>
            <title>{{ trans('public.esg.meta.title') }}</title>
            <meta
                name="description"
                :content="trans('public.esg.meta.description')"
            />
            <link rel="icon" type="image/svg+xml" href="/images/logo-seeo2.svg" />
            <meta property="og:title" :content="trans('public.esg.meta.title')" />
            <meta property="og:description" :content="trans('public.esg.meta.description')" />
            <meta property="og:image" content="/images/og-image.jpg" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="SeeO2" />
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:title" :content="trans('public.esg.meta.title')" />
            <meta property="twitter:description" :content="trans('public.esg.meta.description')" />
            <meta property="twitter:image" content="/images/og-image.jpg" />
        </Head>
        <div class="h-full esg">
            <div id="app">
                <!-- Hero Section -->
                <section class="bg-white py-32" id="esg-intro">
                    <div class="container mx-auto px-4 max-w-7xl">
                        <div class="grid grid-cols-1 lg:grid-cols-2 gap-16">
                            <div class="relative">
                                <h1 class="block text-4xl lg:text-6xl font-bold text-teal-700 mb-6 circle-bg relative z-10">
                                    {{ trans('public.esg.hero.title') }}
                                </h1>
                            </div>
                            <div class="flex flex-col justify-center">
                                <p class="text-xl text-teal-700 mb-12 leading-relaxed">
                                    {{ trans('public.esg.hero.description') }}
                                </p>
                                <div>
                                    <a
                                        :href="localizedPath('/book-meeting')"
                                        class="px-6 py-3 bg-teal-500 text-white rounded-full text-lg font-medium hover:bg-teal-600 transition"
                                    >
                                        {{ trans('public.esg.hero.cta') }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="banner">
                    <img src="/images/colaj.png">
                </section>
                <section id="what-is-esg" class="relative py-8 mt-32">
                    <div class="absolute right-0 top-0 w-full lg:w-3/4 h-full bg-[#115E59]"></div>
                    <div class="container mx-auto px-4 max-w-7xl relative">
                        <div class="grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-16">
                            <div class="relative hidden lg:block">
                            </div>
                            <div class="col-span-1 lg:col-span-3 py-12 text-white">
                                <h2 class="text-3xl lg:text-5xl font-bold mb-6 leading-tight text-white">
                                    {{ trans('public.esg.about.title') }}
                                </h2>
                                <p class="text-lg mb-12">
                                    {{ trans('public.esg.about.description') }}
                                </p>
                                <div class="mt-8">
                                    <a href="https://www.tandfonline.com/doi/full/10.1080/20430795.2015.1118917" 
                                       target="_blank" 
                                       rel="noopener noreferrer" 
                                       class="inline-flex items-center px-6 py-3 border-2 border-white rounded-full text-lg font-medium text-white hover:bg-white hover:text-[#115E59] transition">
                                        {{ trans('public.esg.about.cta') }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="more-about-esg">
                    <div class="container mx-auto px-4 max-w-3xl py-16">
                        <div class="flex flex-col items-start border-l-4 border-[#115E59] pl-8">
                            <span class="text-[#115E59] text-6xl font-serif mb-8">"</span>
                            <h3 class="text-[#115E59] text-2xl font-bold mb-6">
                                {{ trans('public.esg.quote.title') }}
                            </h3>
                            <p class="text-gray-600 text-lg mb-6">
                                {{ trans('public.esg.quote.content1') }}
                            </p>
                            <p class="text-gray-600 text-lg mb-6">
                                {{ trans('public.esg.quote.content2') }}
                            </p>
                            <p class="text-gray-600 text-lg mb-6">
                                {{ trans('public.esg.quote.content3') }}
                            </p>
                            <p class="text-gray-600 text-lg mb-6">
                                {{ trans('public.esg.quote.content4') }}
                            </p>
                            <p class="text-gray-600 text-lg mb-6">
                                {{ trans('public.esg.quote.content5') }}
                            </p>
                            <p class="text-gray-600 text-lg mb-8">
                                {{ trans('public.esg.quote.content6') }}
                            </p>
                           
                        </div>
                    </div>
                </section>
                <!-- About Section -->
                <section class="relative py-8 mt-16" id="esg-co2">
                    <div class="absolute left-0 top-0 w-full lg:w-3/4 h-full bg-[#115E59]"></div>
                    <div class="container mx-auto px-4 max-w-7xl relative">
                        <div class="grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-16">
                            <div class="col-span-1 lg:col-span-3 py-12 text-white">
                                <h2 class="text-3xl lg:text-5xl font-bold mb-6 leading-tight text-white">
                                    {{ trans('public.esg.co2.title') }}
                                </h2>
                                <p class="text-lg mb-12">
                                    {{ trans('public.esg.co2.description') }}
                                </p>
                                <div class="mt-8">
                                    <a href="#" class="inline-flex items-center px-6 py-3 border-2 border-white rounded-full text-lg font-medium hover:bg-white hover:text-[#115E59] transition">
                                        {{ trans('public.esg.co2.cta') }}
                                    </a>
                                </div>
                            </div>
                            <div class="relative hidden lg:block">
                            </div>
                        </div>
                    </div>
                </section>

             
                <section class="py-20" id="social">
                    <div class="container mx-auto px-4">
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
                            <!-- Card 1 -->
                            <div class="relative group overflow-hidden rounded-lg">
                                <div class="aspect-w-16 aspect-h-12">
                                    <img src="/images/card1.jpg" alt="ESG Card 1" 
                                        class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110">
                                </div>
                                <div class="absolute inset-0 bg-gradient-to-t from-[#004432]/90 to-transparent p-8">
                                    <div class="absolute bottom-8 left-8 right-8">
                                        <h3 class="text-2xl font-bold text-white h-16">
                                            {{ trans('public.esg.environmental.title') }}
                                        </h3>
                                        <p class="text-white/90 text-sm h-20">
                                            {{ trans('public.esg.environmental.description') }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Card 2 -->
                            <div class="relative group overflow-hidden rounded-lg">
                                <div class="aspect-w-16 aspect-h-12 h-full">
                                    <img src="/images/card2.jpg" alt="ESG Card 2" 
                                        class="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110">
                                </div>
                                <div class="absolute inset-0 bg-gradient-to-t from-[#004432]/90 to-transparent p-8">
                                    <div class="absolute bottom-8 left-8 right-8">
                                        <h3 class="text-2xl font-bold text-white h-16">
                                            {{ trans('public.esg.social.title') }}
                                        </h3>
                                        <p class="text-white/90 text-sm h-20">
                                            {{ trans('public.esg.social.description') }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Card 3 -->
                            <div class="relative group overflow-hidden rounded-lg">
                                <div class="aspect-w-16 aspect-h-12">
                                    <img src="/images/card3.jpg" alt="ESG Card 3" 
                                        class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110">
                                </div>
                                <div class="absolute inset-0 bg-gradient-to-t from-[#004432]/90 to-transparent p-8">
                                    <div class="absolute bottom-8 left-8 right-8">
                                        <h3 class="text-2xl font-bold text-white h-16">
                                            {{ trans('public.esg.energy.title') }}
                                        </h3>
                                        <p class="text-white/90 text-sm h-20">
                                            {{ trans('public.esg.energy.description') }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                

                <!-- FAQ Section -->
                <section class="relative py-24" id="faq">
                    <div class="container mx-auto px-4 max-w-5xl">
                        <div class="space-y-8">
                            <div v-for="(faq, index) in faqs" :key="index" 
                                class="border-b border-[#56BF98] pb-8">
                                <button @click="toggleFaq(index)" 
                                    class="w-full flex justify-between items-center group">
                                    <span class="font-semibold text-2xl text-[#004432] text-left pr-8">{{ faq.question }}</span>
                                    <span class="text-4xl text-[#56BF98] font-normal" v-if="activeFaq === index">−</span>
                                    <span class="text-4xl text-[#56BF98] font-normal" v-else>+</span>
                                </button>
                                <div v-if="activeFaq === index" 
                                    class="mt-6 text-gray-600 text-lg pr-16">
                                    <p>{{ faq.answer }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <Footer />
    </UnauthLayout>
</template>

<script setup>
import { ref } from "vue";
import { trans } from 'laravel-vue-i18n';
import { Head, usePage } from '@inertiajs/vue3';
import UnauthLayout from "@/Layouts/UnauthLayout.vue";
import Footer from '@/Components/Footer.vue';

const localizedPath = (path) => {
    const currentLocale = usePage().props.locale;
    const cleanPath = path.replace(/^\/en/, '');
    if (currentLocale === 'en') {
        if (cleanPath === '/') {
            return '/en';
        }
        return `/en${cleanPath}`;
    }
    return cleanPath;
};

const faqs = ref([
    {
        question: trans('public.esg.faq.q1'),
        answer: trans('public.esg.faq.a1')
    },
    {
        question: trans('public.esg.faq.q2'),
        answer: trans('public.esg.faq.a2')
    },
    {
        question: trans('public.esg.faq.q3'),
        answer: trans('public.esg.faq.a3')
    },
    {
        question: trans('public.esg.faq.q4'),
        answer: trans('public.esg.faq.a4')
    }
]);

const activeFaq = ref(-1);

const toggleFaq = (index) => {
    activeFaq.value = activeFaq.value === index ? -1 : index;
};
</script>

<style scoped>
.circle-bg::before {
    content: '';
    position: absolute;
    left: -5rem;
    top: -3rem;
    width: 5rem;
    height: 5rem;
    background-color: rgb(204 251 241);
    border-radius: 9999px;
    z-index: 20;
    opacity: 0.5;
}
</style>
